import { render } from "./DataManagerLogDetails.vue?vue&type=template&id=41910ba4&scoped=true"
import script from "./DataManagerLogDetails.vue?vue&type=script&lang=js"
export * from "./DataManagerLogDetails.vue?vue&type=script&lang=js"

import "./DataManagerLogDetails.vue?vue&type=style&index=0&id=41910ba4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41910ba4"]])

export default __exports__